import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCloudArrowUp, faLink } from '@fortawesome/pro-light-svg-icons'

import {
  Box, SectionDivider, SidebarNoticeBox, Text, theme,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import { PublicationBookingModel } from '@models/types'

const getPublicationConfirmationStatus = (confirmationDate?: string, bookingError?: string) => {
  if (confirmationDate) return [theme?.colors?.green, 'Success']
  if (bookingError) return [theme?.colors?.red, 'Failed']

  return [theme?.colors?.faintGrey, 'Pending']
}

const getFTPSyncStatus = (ftp_transfer_successful?: boolean) => {
  if (ftp_transfer_successful) return [theme?.colors?.green, 'Success']
  if (ftp_transfer_successful === false) return [theme?.colors?.red, 'Failed']

  return [theme?.colors?.faintGrey, 'Pending']
}

const Status = (props: { publicationBooking: PublicationBookingModel}) => {
  const { publicationBooking } = props

  const { booking_error, dates, ftp_transfer_successful } = publicationBooking || {}

  const confirmationDate = digObject(dates, 'booking_confirmation.date_time', null)

  const [
    publicationConfirmationColor,
    publicationConfirmationText,
  ] = getPublicationConfirmationStatus(confirmationDate, booking_error)

  const [ftpSyncColor, ftpSyncText] = getFTPSyncStatus(ftp_transfer_successful)

  return (
    <>
      <SectionDivider boxProps={{ marginBottom: 'large' }}>STATUS</SectionDivider>

      <Box fontSize="small" flexDirection="column" marginBottom="large">
        <Box>
          <Text color="bodyFontLightColor" width="100%">Publication Confirmation</Text>

          <Box justifyContent="flex-end">
            <FontAwesomeIcon color={publicationConfirmationColor} icon={faLink} />
            <Text marginLeft="medium">{publicationConfirmationText}</Text>
          </Box>
        </Box>

        {booking_error && (
          <SidebarNoticeBox boxProps={{ marginTop: 'large', marginBottom: 0 }}>
            <SidebarNoticeBox.Title>{booking_error}</SidebarNoticeBox.Title>
          </SidebarNoticeBox>
        )}

        <Box marginTop="large">
          <Text color="bodyFontLightColor" width="100%">FTP Sync</Text>

          <Box justifyContent="flex-end">
            <FontAwesomeIcon color={ftpSyncColor} icon={faCloudArrowUp} />
            <Text marginLeft="medium">{ftpSyncText}</Text>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default Status
